/*
    ###
    getCurrentDate()  ---------------------  日期格式 ----> 2020-11-26 星期四 11:03:21
    ###
*/
export function getCurrentDate() {
  var myDate = new Date();

  var year = myDate.getFullYear(); //年

  var month = myDate.getMonth() + 1; //月

  var day = myDate.getDate(); //日

  var hour = myDate.getHours(); //时

  var min = myDate.getMinutes(); //分

  var seconds = myDate.getSeconds(); //秒

  var days = myDate.getDay();

  switch (days) {

    case 1:

      days = '星期一';

      break;

    case 2:

      days = '星期二';

      break;

    case 3:

      days = '星期三';

      break;

    case 4:

      days = '星期四';

      break;

    case 5:

      days = '星期五';

      break;

    case 6:

      days = '星期六';

      break;

    case 0:
      days = '星期日';

      break;
  }

  var str = year + "-" + zeroFill(month) + "-" + zeroFill(day) + "  " + days + ' ' + zeroFill(hour) + ":" + zeroFill(min) + ":" + zeroFill(seconds);

  return str;

}

function zeroFill(num) {
  return Number(num) < 10 ? '0' + num : num
}

export function getNowDate (){
	let _date = new Date();
	return _date.getFullYear()+"-"+zeroFill(_date.getMonth()+1)+"-"+zeroFill(_date.getDate());
}
export function getYesterday(){
	let _date = new Date();
	let _yesterday = new Date(_date.getTime() - 1000*60*60*24)
	return _yesterday.getFullYear()+"-"+zeroFill(_yesterday.getMonth()+1)+"-"+zeroFill(_yesterday.getDate());
}
export function getLastMonth(){
	let _date = new Date();
	let _year = _date.getFullYear();
	let _month = _date.getMonth();
	if(_month == 0){
		_year -= 1;
		_month = 12;
	}
	return _year+"-"+zeroFill(_month);
}